import { useFetchQuery } from "common/queries/hooks";

import { ControlledSubstanceGuidance } from "../types";
import { keys, urls } from "./constants";

export const useControlledSubstanceGuidanceQuery = ({ enabled }: { enabled: boolean }) => {
  return useFetchQuery<ControlledSubstanceGuidance>(keys.guidance(), {
    fetch: { url: urls.controlledSubstanceGuidance() },
    config: { enabled },
  });
};
